<script>
import { userRoute } from '@src/router'
import { useIndexStore } from '@src/store'
import ProjectsList from '@comp/ProjectsList.vue'
import NewProject from '@comp/NewProject.vue'

export default {
  name: 'Toolbar',
  components: {
    ProjectsList,
    NewProject,
  },
  computed: {
    store () {
      return useIndexStore()
    },
    userName () {
      const user = this.store.user || null
      return user ? user.user_name : '/'
    },
    isCurrentRouteMapRoute () {
      return this.$route.fullPath === '/map'
    },
  },
  methods: {
    handleChangeLanguage (lang) {
      this.$vuetify.locale.current = lang
      this.$language.current = lang
    },
    handleUserClick () {
      this.$router.push({ name: userRoute.name })
    },
  },
}
</script>
<template>
  <v-toolbar
    class="app-toolbar"
    :elevation="4"
    density="compact"
    color="white"
  >
    <div class="logo">
      TRAFFIC
    </div>
    <ProjectsList
      v-if="isCurrentRouteMapRoute"
    />
    <NewProject
      v-if="isCurrentRouteMapRoute"
    />
    <div class="toolbar-buttons-container">
      <v-tooltip
        location="left"
        color="secondary"
      >
        <template v-slot:activator="{ props }">
          <v-btn
            size="small"
            :style="{marginRight: '40px'}"
            v-bind="props"
            color="secondary"
            icon="fas fa-user"
            @click="handleUserClick"
          />
        </template>
        <span>{{ userName }}</span>
      </v-tooltip>
      <div
        v-for="(language, lang) in $language.available"
        :key="lang"
        class="language"
        :class="[lang === $language.current ? 'active' : '']"
        :title="language"
        @click="handleChangeLanguage(lang)"
      >
        {{ lang.toUpperCase() }}
      </div>
    </div>
  </v-toolbar>
</template>
<style lang="scss" scoped>
.logo {
  font-weight: 500;
  font-size: large;
  align-content: center;
}
</style>
